import {
  ComponentType,
  Node
} from './types'
import {Stream} from './api/server'
import {translate} from './i18n.ts'

function getAddableTypes(node: Node): ComponentType[] {
  const type = node.componentType
  if (type === 'AB_SPLITTER') {
    return [
      'AB_SPLITTER_ELEMENT'
    ]
  } else if (type === 'AB_SPLITTER_ELEMENT') {
    return [
      'ACTION',
      'CONNECTOR',
      'TIMER'
    ]
  } else if (type === 'ACTION') {
    return [
      'AB_SPLITTER',
      'ACTION',
      'CONNECTOR',
      'TIMER'
    ]
  } else if (type === 'CONNECTOR') {
    return [
      'CONNECTOR_ELEMENT'
    ]
  } else if (type === 'CONNECTOR_ELEMENT') {
    return [
      'AB_SPLITTER',
      'ACTION',
      'CONNECTOR',
      'TIMER'
    ]
  } else if (type === 'TIMER') {
    return [
      'AB_SPLITTER',
      'ACTION',
      'CONNECTOR'
    ]
  } else if (type === 'TRIGGER') {
    return [
      'AB_SPLITTER',
      'ACTION',
      'CONNECTOR',
      'TIMER'
    ]
  }
  return []
}

interface NodeActions {
  canCopy: boolean;
  canDelete: boolean
  canDeleteWithChildren: boolean
  addTypes: ComponentType[]
}
export function getAllowedNodeActions(node: Node): NodeActions {
  const type = node.componentType
  return {
    canCopy: type !== 'TRIGGER',
    canDelete: (
      type !== 'TRIGGER' &&
      type !== 'AB_SPLITTER' &&
      type !== 'AB_SPLITTER_ELEMENT' &&
      type !== 'CONNECTOR' &&
      type !== 'CONNECTOR_ELEMENT'
    ),
    canDeleteWithChildren: type !== 'TRIGGER',
    addTypes: getAddableTypes(node)
  }
}

export function isContainerNode(node: Node): boolean {
  return node.componentType === 'AB_SPLITTER' ||
    node.componentType === 'CONNECTOR'
}

export function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function pascalCase(value: string) {
  return value
    .split(/[^a-z]+/i)
    .map(d => capitalize(d.toLowerCase()))
    .join('')
}

export function getNodeComponent(type: ComponentType, suffix?: string) {
  if (
    type === 'AB_SPLITTER' ||
    type === 'AB_SPLITTER_ELEMENT' ||
    type === 'ACTION' ||
    type === 'CONNECTOR' ||
    type === 'CONNECTOR_ELEMENT' ||
    type === 'TIMER' ||
    type === 'TRIGGER'
  ) {
    return pascalCase(suffix ? type + ' ' + suffix : type)
  }
}

export function isUniqueStreamName(streams: Stream[], name: string): boolean {
  const lower = name.toLowerCase()
  return !streams.find(d => {
    return d.status !== 'deleted' &&
      d.name.toLowerCase() === lower
  })
}

export function getStreamBadge(stream: Stream) {
  let key: string = stream.status
  let color = 'default'
  if (stream.status === 'published') {
    if (stream.isDisabled) {
      key = 'disabled'
      color = 'warning'
    } else {
      color = 'success'
    }
  }
  return {
    label: translate(`common.status.${key}`),
    status: color
  }
}
